const PATH_FEATURES: ReadonlyArray<readonly [string, string]> = [
  ['/admin/automations', 'automations'],
  ['/admin/comment-automations', 'automations'],
  ['/admin/dm-automations', 'automations'],
  ['/automations', 'automations'],
  ['/products', 'products'],
  ['/services', 'services'],
  ['/consultations', 'consultations'],
  ['/appointments', 'consultations'],
  ['/invoices', 'invoices'],
  ['/payments', 'invoices'],
  ['/ai/tools/mcp', 'mcpTools'],
  ['/ai/tools/api', 'api'],
  ['/ai/tools/data', 'knowledgeBase'],
  ['/ai/tools/plugins', 'aiEmployees'],
  ['/ai/tools/skills', 'aiEmployees'],
  ['/ai/tools/commands', 'aiEmployees'],
  ['/ai/tools/hooks', 'aiEmployees'],
  ['/ai/tools/rules', 'aiEmployees'],
  ['/ai/tools/transfer', 'aiEmployees'],
  ['/ai/api-tools', 'api'],
  ['/ai/knowledge', 'knowledgeBase'],
  ['/knowledge', 'knowledgeBase'],
  ['/ai/subagents', 'aiEmployees'],
  ['/ai/orchestrators', 'aiEmployees'],
  ['/ai/config', 'aiEmployees'],
  ['/settings/ai', 'aiEmployees'],
  ['/conversations', 'inbox'],
  ['/calls', 'calls'],
  ['/contacts', 'contacts'],
  ['/owners', 'contacts'],
  ['/tasks', 'tasks'],
  ['/calendar', 'calendar'],
  ['/dashboard', 'basicAnalytics'],
  ['/web-widget-demo', 'channels'],
];

export const planFeatureForPath = (pathname: string): string | null => {
  const path = pathname.split('?')[0] || '/';
  for (const [prefix, feature] of PATH_FEATURES) {
    if (path === prefix || path.startsWith(`${prefix}/`)) {
      return feature;
    }
  }

  return null;
};

/** Features a platform operator can turn on or off for a plan. Matches the API catalog. */
export const PLAN_FEATURE_TOGGLES = [
  'channels',
  'inbox',
  'aiEmployees',
  'aiCustomers',
  'contacts',
  'tasks',
  'calendar',
  'knowledgeBase',
  'basicAnalytics',
  'mcpTools',
  'automations',
  'products',
  'services',
  'consultations',
  'invoices',
  'api',
  'calls',
  'higherAi',
  'workspaces',
  'webhooks',
  'advancedApi',
  'sso',
  'advancedPermissions',
  'prioritySupport',
] as const;
